import { compiledClientConfig } from "config";
import { useEffect } from "react";
import { gainsightInit } from "utils/gainsight";

const GAINSIGHT_SDK_URL = "https://web-sdk.aptrinsic.com/api/aptrinsic.js";

export const useGainsightPX = () => {
  useEffect(() => {
    const clientId = compiledClientConfig.gainsightClientId;
    if (!clientId) return;

    if (!window.aptrinsic) {
      const aptrinsicFunc: Aptrinsic = function (...args) {
        (aptrinsicFunc.q = aptrinsicFunc.q || []).push(args);
      };
      aptrinsicFunc.p = clientId;
      aptrinsicFunc.c = undefined;

      window.aptrinsic = aptrinsicFunc;
    }

    const script = document.createElement("script");
    script.async = true;
    script.src = `${GAINSIGHT_SDK_URL}?a=${clientId}`;

    script.onload = () => {
      void gainsightInit();
    };
    const firstScript = document.getElementsByTagName("script")[0];
    firstScript.parentNode?.insertBefore(script, firstScript);
  }, []);
};
